var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13879 8.04208L1.92723 2.58754H14.9145L10.2814 8.04208H6.13879ZM6.5549 9.67844H9.84005V14.329L6.5549 15.7832V9.67844ZM0.286852 3.14608L4.91452 9.13844V16.2032C4.91452 17.1894 5.93292 17.8504 6.83852 17.449L10.6712 15.7515C11.1662 15.5334 11.4848 15.0446 11.4848 14.5057V9.16026L16.5505 3.19517C17.3028 2.30935 16.671 0.951172 15.5058 0.951172H1.37095C0.235385 0.951172 -0.406313 2.24935 0.286852 3.14608ZM17.5065 9.40572C17.5065 9.18872 17.4199 8.98061 17.2659 8.82718C17.1119 8.67374 16.903 8.58753 16.6852 8.58753C16.4674 8.58753 16.2585 8.67374 16.1045 8.82718C15.9504 8.98061 15.8639 9.18872 15.8639 9.40572V10.7694H14.4951C14.2773 10.7694 14.0684 10.8556 13.9144 11.009C13.7603 11.1624 13.6738 11.3705 13.6738 11.5875C13.6738 11.8045 13.7603 12.0126 13.9144 12.1661C14.0684 12.3195 14.2773 12.4057 14.4951 12.4057H15.8639V13.7694C15.8639 13.9863 15.9504 14.1945 16.1045 14.3479C16.2585 14.5013 16.4674 14.5875 16.6852 14.5875C16.903 14.5875 17.1119 14.5013 17.2659 14.3479C17.4199 14.1945 17.5065 13.9863 17.5065 13.7694V12.4057H18.8753C19.0931 12.4057 19.302 12.3195 19.456 12.1661C19.61 12.0126 19.6966 11.8045 19.6966 11.5875C19.6966 11.3705 19.61 11.1624 19.456 11.009C19.302 10.8556 19.0931 10.7694 18.8753 10.7694H17.5065V9.40572Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector1.ca1e214ee236cbdefb3a3b0d530099e4.svg";
export { ForwardRef as ReactComponent };